import enterprise from './enterprise'
import input from './input'
import account from './account'
import integral from './integral'
import report from './report'


const $api = Object.assign({},
    enterprise,
    input,
    account,
    integral,
    report
);
export default $api;


// WEBPACK FOOTER //
// ./src/service/enterprise/index.js